import { post } from 'services/api';
import { EventData, MultidayType } from 'features/common/types';

export interface CalculateTotalsRequest {
	tickets: Record<number, number>;
	code?: string;
	include_processor_fees?: boolean;
}

export interface TicketTypeDetail {
	ticket_type_id: number;
	ticket_type_name: string;
	quantity: number;
	unit_price: number;
	subtotal: number;
	fixed_fee?: number;
	percentage_fee?: number;
	custom_fees?: number;
}

export interface CalculateTotalsResponse {
	subtotal: number;
	fees: number;
	taxes: number;
	total: number;
	// `subtotal` and `total` are already net of `discount` when a promo `code` is sent
	// (calculate_totals.go: Subtotal = subtotal - discount). `discount` is informational.
	discount?: number;
	promo_code_applied?: boolean;
	promo_code_error?: string;
	details: TicketTypeDetail[];
}

export const callCalculateTotalsAPI = (request: CalculateTotalsRequest): Promise<CalculateTotalsResponse> =>
	post('/public/ticketing/calculate-totals', request);

export const prepareCalculateTotalsRequest = (
	event: EventData | null,
	multiday: MultidayType[] | null,
	isMultiDay: boolean,
	promoCode?: string
): CalculateTotalsRequest | null => {
	const tickets: Record<number, number> = {};

	if (isMultiDay && multiday) {
		multiday.forEach((day) => {
			day.ticketTypes.forEach((tt) => {
				if (tt.quantity > 0) tickets[tt.ID] = (tickets[tt.ID] || 0) + tt.quantity;
			});
		});
	} else if (event) {
		event.ticketTypes.forEach((tt) => {
			if (tt.quantity > 0) tickets[tt.ID] = tt.quantity;
		});
	}

	if (Object.keys(tickets).length === 0) return null;

	return { tickets, code: promoCode || undefined };
};
